import { useAuth } from "@/lib/auth";
import { Eye, X } from "lucide-react";
import { toast } from "sonner";

export default function ImpersonationBanner() {
  const { user, endImpersonation } = useAuth();

  if (!user || !user.impersonated_by) return null;

  const handleExit = async () => {
    try {
      await endImpersonation();
      toast.success("Exited View-As mode");
      // Hard nav so admin auth state is fully applied
      window.location.assign("/dashboard/admin/users");
    } catch {
      toast.error("Failed to exit View-As");
    }
  };

  return (
    <div
      className="sticky top-0 z-[55] bg-amber-400 text-black px-4 py-2 flex items-center justify-center gap-3 text-sm font-medium"
      data-testid="impersonation-banner"
    >
      <Eye size={14} />
      <span className="font-display uppercase tracking-wider text-xs">View-As</span>
      <span className="opacity-80">
        You are viewing as <span className="font-bold">{user.email}</span> ({user.role}) — read-only.
      </span>
      <button
        onClick={handleExit}
        className="ml-2 inline-flex items-center gap-1.5 bg-black text-amber-300 px-3 py-1 rounded-md text-xs font-display font-bold uppercase tracking-wider hover:bg-neutral-900"
        data-testid="exit-impersonation-btn"
      >
        <X size={11} /> Exit View
      </button>
    </div>
  );
}
